<template>
  <div class="publicizeList">
    <div class="bgc">
      <div class="bx-content">
        <div class="banner">
          <div class="weizhi">
            <i class="iconfont icon-dizhi"></i> 当前位置：首页 > {{titleTex}}
          </div>
          <div class="page-cancel" @click="$router.go(-1)">
            <i class="icon iconfont icon-jiantouzuo1"></i>返回
          </div>
        </div>
        <div class="search">
          <input type="text" placeholder="关键词搜索">
          <div class="btn">搜索</div>
        </div>
        <div class="list-box">
          <div class="item" v-for="item in lists" :key="item.id" @click="to('/admin/detail',item.id)">
            <div class="tit ovHide2">{{item.title}}</div>
            <div class="time">{{item.publish_time}}</div>
          </div>
         </div>

        <div class="masses-pagebox ">
          <el-pagination
            :current-page.sync="search.page"
            :page-size="search.limit"
            :total="search.total"
            background
            class="page-all margin-top self-end"
            layout="prev, pager, next"
            @current-change="list">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {org_indexlst} from "@/api";

export default {
  name: "policyList",
  data() {
    return {
      type: 2,
      titleTex:'通知公告',
      lists:[],
      search:{
        keyword:'',
        page:1,
        limit:10,
        total:0,
      },
    }
  },
  components: {},
  created() {
    this.$emit("setActive", {
      headActive: 1
    })
    this.list()
  },
  methods: {
    async list(){
      let _data = await org_indexlst(
        this.search.keyword,
        this.search.page,
        this.search.limit,
        this.type
      );
      this.lists = _data.data.data;
      this.search.total = _data.data.total;
    },
    searchFun(){
      this.search.page = 1
      this.list()
    },
    to(path,id){
      this.$router.push({
        path: path,
        query: {
          id: id,
          name:this.titleTex
        }
      })
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.publicizeList {
  .bgc {
    width: 100%;
    padding-bottom: 50px;
    background-image: linear-gradient(0deg,
      #ffffff 0%,
      #ebf4ff 100%);
    .list-box {
      width: 100%;
      background-color: #ffffff;
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 30px;
      .item {
        width: 100%;
        padding: 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #cecece;
        cursor: pointer;
        &:hover {
          .item-cont {
            .item-title {
              color: #0d7bff;
            }
          }
          .item-date {
            background-color: #428ffb;
            b {
              color: #ffffff;
            }
            p {
              color: #ffffff;
            }
          }
        }
        .item-cont {
          flex: 1;
          width: 0;
          height: 100px;
          padding: 12px 0;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .item-desc {
            width: 100%;
            font-size: 16px;
            color: #b3b3b3;
          }
          .item-title {
            width: 100%;
            font-size: 22px;
            color: #141c24;
          }
        }
        .item-date {
          width: 100px;
          height: 100px;
          background-color: #ffffff;
          border: solid 1px #cecece;
          display:flex;
          justify-content: center;
          flex-direction: column;
          margin-right: 30px;
          p {
            width: 100%;
            text-align: center;
            font-size: 20px;
            color: #b3b3b3;
          }
          b {
            width: 100%;
            text-align: center;
            font-size: 49px;
            color: #b3b3b3;
            line-height: 55px;
          }
        }
      }
    }
    .search {
      width: 100%;
      height: 60px;
      background-color: #ffffff;
      box-shadow: 8px  2px 8px 1px
      rgba(0, 46, 108, 0.17);
      border-radius: 4px;
      border: solid 1px #ededed;
      padding: 2px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 20px auto;
      .btn {
        width: 100px;
        height: 54px;
        background-image: linear-gradient(-90deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 6px;
        text-align: center;
        line-height: 56px;
        font-size: 16px;
        color:#ffffff;
        cursor: pointer;
      }
      input {
        flex: 1;
        margin-left: 30px;
        font-size: 16px;
        height: 56px;
        color: #333333;
      }
    }
  }
  .banner {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #dfe1f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 100%;
      height: auto;
    }
    .weizhi {
      font-size: 16px;
      letter-spacing: 1px;
      color: #999999;
      i {
        font-size: 18px;
        color: #999999;
      }
    }
  }
}
</style>


